/**
 * Suite Run Helpers
 *
 * @module features/releases/components/suiteRun
 * @description Shared pass-rate math and status labels for a checkpoint
 * commit's workflow suite execution (`TimelineSuiteRun`). Used by
 * `TimelineNode` (the pass-rate ring drawn on the node) and
 * `TimelineRunEntry` (the band's meta-line link to the suite execution).
 */

import type { TimelineSuiteRun } from '../hooks/useReleaseTimeline';

export const suiteStatusLabels: Record<TimelineSuiteRun['status'], string> = {
  queued: 'Queued',
  running: 'Running',
  completed: 'Completed',
  completed_with_errors: 'Completed with failures',
  completed_with_inconclusive: 'Completed with platform errors',
  canceled: 'Canceled',
  timeout: 'Timed out',
};

export function getSuitePassRate(suiteRun: TimelineSuiteRun): number | null {
  const settled = suiteRun.successfulWorkflows + suiteRun.failedWorkflows;
  return settled > 0 ? Math.round((suiteRun.successfulWorkflows / settled) * 100) : null;
}
